export const Bang = () => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" className="m-1 mt-0.5">
      <path
        d="M6.99992 0.833344C3.31992 0.833344 0.333252 3.82001 0.333252 7.50001C0.333252 11.18 3.31992 14.1667 6.99992 14.1667C10.6799 14.1667 13.6666 11.18 13.6666 7.50001C13.6666 3.82001 10.6799 0.833344 6.99992 0.833344ZM7.66658 10.8333H6.33325V9.50001H7.66658V10.8333ZM7.66658 8.16668H6.33325V4.16668H7.66658V8.16668Z"
        fill="#B22E2E"
      />
    </svg>
  )
}
